import { useCallback } from "react";

import { useLocation } from "@cinnamon/design-system/hooks";

import { type FROM_PAGE_MANAGEMENT } from "@/constants/fromPageManagement";
import { FROM_PAGE_MANAGEMENT_ROUTE } from "@/constants/route";
import { type LocationState } from "@/types/global";

import useTenantAwareNavigation from "./useTenantAwareNavigation";

export interface HandleReturnManagementPage {
  fromPageManagement: FROM_PAGE_MANAGEMENT;
  callbackStateNull?: () => void;
}

export const useHandleReturnManagementPage = (
  fromPageManagement: FROM_PAGE_MANAGEMENT,
  callbackStateNull?: () => void
): (() => void) => {
  const navigate = useTenantAwareNavigation();
  const location = useLocation();

  return useCallback((): void => {
    if (location.state?.isHistoryNavigationPermitted) {
      navigate(-1);
      return;
    }

    if ((location.state as LocationState)?.[fromPageManagement]) {
      navigate((location.state as LocationState)?.[fromPageManagement]);
      return;
    }

    if (callbackStateNull) {
      callbackStateNull();
    } else {
      navigate(FROM_PAGE_MANAGEMENT_ROUTE[fromPageManagement]);
    }
  }, [callbackStateNull, fromPageManagement, location.state, navigate]);
};
